import type { IAuthor, ISiteNavigation } from '@anywayseo/tools';
import { StaticImage } from 'gatsby-plugin-image';

export const author: IAuthor = {
  name: 'Julian Blaustein',
  role: 'Game Expert',
  bio: 'My name is Julian Blaustein, and I’m dedicated to exploring and reviewing the world of online casinos and slot games. I enjoy analyzing the latest slots to discover their unique features, bonus mechanics, and entertainment value. I also evaluate online casinos for their reliability, bonus offers, and overall player experience. My mission is to guide players toward the safest and most enjoyable gaming options available online.',
  avatar: (
    <StaticImage src={'./assets/authors/julian-blaustein.jpg'} alt='Julian Blaustein' style={{ borderRadius: '50%' }} />
  ),
};

export const localNavigation: ISiteNavigation = {
  header: {},
  footer: {
    en: [
      { slug: 'privacy-policy', label: 'Privacy Policy' },
      { slug: 'cookie-policy', label: 'Cookie Policy' },
      { slug: 'terms-and-conditions', label: 'Terms & Conditions' },
      { slug: 'contacts', label: 'Contacts' },
    ],
  },
};
